<template>
  <b-form-group
    label="CPF/CNPJ"
    label-for="cpf-cnpj"
    description="Digite o CPF no formato XXX.XXX.XXX-XX ou o CNPJ no formato XX.XXX.XXX/XXXX-XX"
  >
    <b-form-input
      id="cpf-cnpj"
      v-model="formattedCpfCnpj"
      type="text"
      placeholder="XXX.XXX.XXX-XX ou XX.XXX.XXX/XXXX-XX"
      required
      :state="cpfCnpjState"
      aria-describedby="cpf-cnpj-feedback"
      @blur="validateCpfCnpj"
    ></b-form-input>
    <b-form-invalid-feedback id="cpf-cnpj-feedback">
      Por favor, insira um CPF ou CNPJ válido.
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'CpfCnpjInput',
  props: {
    /**
     * The CPF or CNPJ value, expected to be a string of digits.
     * @type {String}
     * @required
     */
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cpfCnpjState: null,
    };
  },
  computed: {
    formattedCpfCnpj: {
      get() {
        return this.formatCpfCnpj(this.value);
      },
      set(newValue) {
        this.$emit('input', this.cleanCpfCnpj(newValue));
      },
    },
  },
  methods: {
    /**
     * Formats a CPF or CNPJ string to the appropriate format.
     * @param {String} value - The CPF or CNPJ string to format.
     * @returns {String} - The formatted CPF or CNPJ string.
     */
    formatCpfCnpj(value) {
      const cleaned = value.replace(/\D/g, '');
      if (cleaned.length <= 11) {
        // CPF format
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/);
        if (match) {
          return `${match[1]}.${match[2]}.${match[3]}-${match[4]}`;
        }
      } else {
        // CNPJ format
        const match = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/);
        if (match) {
          return `${match[1]}.${match[2]}.${match[3]}/${match[4]}-${match[5]}`;
        }
      }
      return value;
    },
    /**
     * Removes all non-numeric characters from a string.
     * @param {String} value - The string to clean.
     * @returns {String} - The cleaned string containing only numeric characters.
     */
    cleanCpfCnpj(value) {
      return value.replace(/\D/g, '');
    },
    /**
     * Validates if the input is a valid CPF or CNPJ.
     */
    validateCpfCnpj() {
      const cleaned = this.cleanCpfCnpj(this.value);
      const isValidCpf = cleaned.length === 11;
      const isValidCnpj = cleaned.length === 14;
      this.cpfCnpjState = isValidCpf || isValidCnpj;
    },
  },
};
</script>
